/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import Alpine from 'alpinejs';
import Accordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import HeaderMenu from './navigation/header-menu';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import Modal from './modules/modal';
import ResponsiveImage from './modules/responsive-image';
import Video from './modules/video';
import NumberAnimation from './modules/number-animation';
import SliderAlbert from './modules/slider-albert';
import SliderAnita from './modules/slider-anita';
import SliderMartin from './modules/slider-martin';
import CardsTeam from './modules/cards-team';
import SliderTypo from './modules/slider-typo';
import AOSClass from './modules/aos';
import ParallaxAnimation from './modules/parallax';
import Hero from './modules/hero';
import CalculatorCollapse from './modules/calculatorCollapse';
import Calculator from './modules/calculator';
import SlideIns from './modules/slide-ins';

const siteInitialization = () => {
	CookieByte.init();
	HeaderMenu.init();
	Accordion.initAll();
	ResponsiveImage.initAll();
	MediaViewer.init();
	Modal.initAll();
	ImageGallery.initAll();
	Form.init();
	Video.initAll();
	NumberAnimation.init();
	SliderAlbert.initAll();
	SliderAnita.initAll();
	SliderMartin.initAll();	
	CardsTeam.init();
	SliderTypo.initAll();
	AOSClass.init();
	ParallaxAnimation.init();
	Hero.init();
	CalculatorCollapse.init();
	Calculator.init();
	SlideIns.init();

	window.Alpine = Alpine;	
	Alpine.start();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
